// extracted by mini-css-extract-plugin
export default {"text":"NotFoundPage_text__ucxgo","button":"NotFoundPage_button__c9kFP"};